import axios from 'axios'

const state = {
  user: null,
  baseData: null,
  token: null,
  pwdChangeRequired: false
}

const getters = {
  isAuthenticated: (state) => !!state.user,
  baseData: (state) => state.baseData,
  user: (state) => state.user,
  token: (state) => state.token
}

const actions = {
  async Register ({dispatch}, form) {
    await axios.post('register', form)
    let UserForm = new FormData()
    UserForm.append('username', form.username)
    UserForm.append('password', form.password)
    await dispatch('LogIn', UserForm)
  },

  async LogIn ({commit}, user) {
    let authData = await axios.post('/api/login', user)
    if (authData.data) {
      console.log('Editor*innen, ' + authData.data.baseData.version + ' by multimedia-werkstatt.com')
      await commit('setData', authData.data)
      return true
    }
    return false
  },
  async LogOut ({ commit }) {
    await commit('logout')
  },
  async newToken ({ commit }, token) {
    await commit('setToken', token)
  },
  async setBaseData ({ commit }, baseData) {
    await commit('setBaseData', baseData)
  }
}

const mutations = {
  setData (state, data) {
    state.user = data.user
    state.baseData = data.baseData
    state.pwdChangeRequire = data.pwdChangeRequire
    state.token = data.token
  },
  setUser (state, user) {
    state.user = user
  },
  setBaseData (state, baseData) {
    state.baseData = baseData
  },
  setPwdChangeRequired (state, pwdChangeRequired) {
    state.pwdChangeRequired = pwdChangeRequired
  },
  setToken (state, token) {
    state.token = token
  },
  logout (state) {
    state.user = null
    state.token = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/main/vue/store/modules/auth.js